import { getI18n } from '@/helpers/i18n';
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';

function routeGuardFormConfirm(isDirty: () => boolean, notSavedMsg?: string): boolean {
    if (isDirty && isDirty()) {
        if (window.confirm(notSavedMsg || getI18n().t('form_not_saved'))) {
            return true
        } else {
            return false;
        }
    } else {
        return true;
    }
}

export function registerFormRouteGuard(isDirty: () => boolean): void {
    onBeforeRouteUpdate(() => {
        return routeGuardFormConfirm(isDirty)
    })

    onBeforeRouteLeave(() => {
        return routeGuardFormConfirm(isDirty)
    })
}